const geoCoordinates = {
  India: {
    latitude: 20.593684,
    longitude: 78.96288,
  },
  'United States': {
    latitude: 37.09024,
    longitude: -95.712891,
  },
  'United Arab Emirates': {
    latitude: 23.424076,
    longitude: 53.847818,
  },
};

const getLatitude = name => {
  return geoCoordinates[name].latitude;
};

const getLongitude = name => {
  return geoCoordinates[name].longitude;
};

export const MapUtil = {
  getLatitude,
  getLongitude,
};
